var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5083 6.58661C13.302 7.04486 13.302 8.19047 12.5083 8.64868L1.79339 14.835C0.999693 15.2932 0.00756836 14.7204 0.00756836 13.8039L0.00756908 1.43139C0.00756908 0.5149 0.999693 -0.0579036 1.79339 0.400339L12.5083 6.58661Z",
    fill: "black"
  })));
};
export default SvgPlayButton;